import { useFeature } from "src/core/common/hooks/useFeature";
import FEATURES from "src/core/constants/features";

export const useIsCustomFieldFeatureEnabled = () =>
  useFeature(FEATURES.CUSTOM_FIELDS);
